import { Card, Form, Space, Badge } from 'antd';
import { PictureOutlined } from '@ant-design/icons';
import { DatosBasicos } from './DatosBasicos';
import { DetallesPokemon } from './DetallesPokemon';
import { FormActions } from './FormActions';

export const PokemonFormCard = ({
    canEdit,
    form,
    detalleDatos,
    tiposPrincipal,
    preevoluciones,
    onSubmit,
    onCancel,
    isLoading
}) => {
    return (
        <Card
            title={
                <Space>
                    <PictureOutlined style={{ color: '#1890ff' }} />
                    <span>Información del Pokémon</span>
                </Space>
            }
            style={{
                borderRadius: '12px',
                border: '1px solid #f0f0f0',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
            }}
            extra={
                canEdit && (
                    <Badge status="processing" text="Modo edición activo" />
                )
            }
        >
            <Form
                disabled={!canEdit}
                style={{ padding: '20px 0' }}
                layout='vertical'
                onFinish={onSubmit}
                form={form}
                size="large"
            >
                <DatosBasicos
                    detalleDatos={detalleDatos}
                    tiposPrincipal={tiposPrincipal}
                    preevoluciones={preevoluciones}
                />

                <DetallesPokemon
                    detalleDatos={detalleDatos}
                    preevoluciones={preevoluciones}
                />
                <FormActions
                    canEdit={canEdit}
                    onCancel={onCancel}
                    isLoading={isLoading}
                />
            </Form>
        </Card>
    );
};
